import type { CardProps, LayoutBaseSpacingProps } from '@bos/ui';
import { Card } from '@bos/ui';

import type { ReplaceTestIdWithAppOne } from '../const/testIds';
import { DEFAULT_CARD_CONTENT_SPACING } from '../constants';

export type AppCardProps = ReplaceTestIdWithAppOne<CardProps>;

export const AppCard = ({ contentSpacing, ...props }: AppCardProps) => {
	const cardContentSpacing: LayoutBaseSpacingProps = contentSpacing
		? contentSpacing
		: DEFAULT_CARD_CONTENT_SPACING;

	return <Card contentSpacing={cardContentSpacing} {...props} />;
};
